export default __webpack_public_path__ + "static/media/notFound.a6f63228.png";